import React from 'react';
import CarouselProps from '../Carousel/props';

// Registry to store carousel component to break circular dependency
let CarouselComponent: React.ComponentType<CarouselProps> | null = null;

export const registerCarousel = (component: React.ComponentType<CarouselProps>) => {
  CarouselComponent = component;
};

export const getCarousel = (): React.ComponentType<CarouselProps> | null => {
  // If already registered, return it
  if (CarouselComponent) {
    return CarouselComponent;
  }
  
  // Try to load carousel dynamically (for backward compatibility)
  try {
    // Use dynamic import that works in both Node.js and browser environments
    // istanbul ignore next: Browser environment branch cannot be tested in Node.js
    const carouselModule = typeof require !== 'undefined' ? require('../Carousel/Carousel') : null;
    if (carouselModule?.default) {
      CarouselComponent = carouselModule.default;
      return CarouselComponent;
    }
  } catch {
    // Carousel not available, will be handled gracefully
  }
  
  return null;
};

// Reset function for testing purposes
export const resetCarouselRegistry = () => {
  CarouselComponent = null;
};

export default { registerCarousel, getCarousel, resetCarouselRegistry };
